import { Spin, Typography, Progress } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Title } = Typography;

const LoadingPage = () => {

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: '#f0f2f5', // Sayfa arka planı
      }}
    >
      {/* Logo */}
      <img
        src="https://material.parts-soft.net/webshop-media/logo.svg"
        alt="Logo"
        style={{
          width: 120,
          borderRadius: '50%',
          marginBottom: 20,
        }}
      />

      {/* Loading Spinner */}


      {/* Hoşgeldiniz Mesajı */}
      <Title level={3} style={{ marginTop: 20, fontWeight: 700, textAlign: 'center' }}>
        {/* Parts-Soft'a Hoşgeldiniz! */}
        Welcome to Parts-Soft!
      </Title>
      <Typography.Paragraph style={{ textAlign: 'center', color: '#555' }}>
        {/* Sayfanız yükleniyor, lütfen bekleyin... */}
        Your page is loading, please wait...        
      </Typography.Paragraph>

      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
        tip="Yükleniyor..."
      />
    </div>
  );
};

export default LoadingPage;
